import { OfferObjectAvailability } from '@/api/v2/requests/offers';
export const getDisplayPriceForAvailability = (availability, contractTable) => {
    if (!availability)
        return null;
    const local = availability.local;
    const global = availability.global;
    if (!local)
        return null;
    const isBothExternal = !!(local.isFirstHalfExternal && local.isSecondHalfExternal);
    const isBothInContract = global?.firstHalfAvailability === OfferObjectAvailability.IN_CONTRACT &&
        global?.secondHalfAvailability === OfferObjectAvailability.IN_CONTRACT;
    if (isBothExternal || (isBothInContract && !contractTable)) {
        return 0;
    }
    if (local.price === null || local.price === undefined) {
        return null;
    }
    return Number(local.price);
};
export const buildPinnedMonthlySummaryRow = (rows, columns, { contractTable, id }) => {
    const monthColumnKeys = columns
        .map((column) => column.colId)
        .filter((colId) => typeof colId === 'string' && /^\d{4}-\d{2}$/.test(colId));
    const monthlySums = new Map();
    monthColumnKeys.forEach((monthKey) => monthlySums.set(monthKey, 0));
    rows.forEach((row) => {
        monthColumnKeys.forEach((monthKey) => {
            const [year, month] = monthKey.split('-').map(Number);
            const availability = row.availability?.find((item) => item.year === year && item.month === month);
            const price = getDisplayPriceForAvailability(availability, contractTable);
            if (price === null)
                return;
            monthlySums.set(monthKey, (monthlySums.get(monthKey) || 0) + price);
        });
    });
    const availability = Array.from(monthlySums.entries()).map(([key, price]) => {
        const [year, month] = key.split('-').map(Number);
        return {
            year,
            month,
            local: {
                price,
            },
        };
    });
    return {
        id,
        availability,
    };
};
